import { useContext } from 'react';
import { AuthContext } from 'src/context/AuthContext';
import { ErrorHandler } from 'src/utils/errorHandler';

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    const error = new Error('useAuth must be used within an AuthProvider');
    ErrorHandler.handleError(error, { rethrow: true });
  }
  return context;
};
